<template>
  <div class="bg-white" :key="this.showChart">
    <ul class="divide-y divide-gray-200">
      <li v-for="levelNumber in this.tablePaginatedData" :key="levelNumber">
        <a
          href="javascript:void(0)"
          @click="
            level === 'callQueues'
              ? this.$router.push(
                  `/pbx-level-detail/${level}/${levelNumber.callQueue}`
                )
              : this.$router.push(
                  `/pbx-level-detail/${level}/${levelNumber.extension}`
                )
          "
          class="block hover:bg-gray-50"
        >
          <div class="px-4 py-4 flex items-center sm:px-6">
            <div
              class="min-w-0 flex-1 sm:flex sm:items-center sm:justify-between"
            >
              <div class="inline-flex">
                <div class="flex text-sm">
                  <p
                    :class="`font-medium truncate encom_dark_text `"
                    v-if="level === 'callQueues'"
                  >
                    {{ levelNumber.callQueue }}
                  </p>
                  <p
                    :class="`font-medium truncate encom_dark_text `"
                    v-if="level === 'extensions'"
                  >
                    {{ levelNumber.extension }}
                  </p>
                </div>
                <div
                  v-if="this.$route.path === '/pbx-callqueue'"
                  class="ml-10 flex"
                >
                  <div class="flex items-center text-sm text-gray-500">
                    <p>
                      {{ levelNumber.name }}
                    </p>
                  </div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-5 w-5 text-gray-500 ml-3"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                    />
                  </svg>
                </div>
                <div
                  v-if="this.$route.path === '/pbx-extension'"
                  class="ml-10 flex"
                >
                  <div class="flex items-center text-sm text-gray-500">
                    <p>
                      {{ levelNumber.name }}
                    </p>
                  </div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-5 w-5 ml-3 text-gray-500"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                    />
                  </svg>
                </div>

                <div
                  v-if="this.$route.path === '/pbx-extension'"
                  class="ml-10 flex"
                >
                  <div class="flex items-center text-sm text-gray-500">
                    <p></p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <ChevronRightIcon
                class="h-5 w-5 text-gray-400"
                aria-hidden="true"
              />
            </div>
          </div>
        </a>
      </li>
    </ul>
    <div v-if="tablePaginatedData.length < 1" class="text-center p-5">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="mx-auto h-10 w-10 text-gray-400"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
        />
      </svg>
      <h3 class="mt-2 text-xl font-medium text-gray-900">
        {{ $t("warning.noDataFoundTitle") }}
      </h3>
      <p class="mt-1 text-base text-gray-500">
        {{ $t("warning.noResultFoundDescription") }}
      </p>
    </div>
  </div>
</template>

<script>
import { ChevronRightIcon, ChevronDownIcon } from "@heroicons/vue/solid";

export default {
  name: "PBXLevelList",
  props: ["level", "tablePaginatedData"],
  components: {
    ChevronRightIcon,
    ChevronDownIcon,
  },
  setup() {
    return {
      showChart: false,
      showIdx: "",
    };
  },
  methods: {
    setShowChart(idx) {
      // check if the index of the item on the list is different from the one that is active, and if the chart is opened
      // when clicked - if the index is not the one active - it will open the one that was clicked and close the one that was active
      if (this.showIdx !== "" && idx != this.showIdx && this.showChart) {
        this.showIdx = idx;
        this.showChart = true;
      } else {
        this.showChart = !this.showChart;
        this.showIdx = idx;
      }
      this.$forceUpdate();
    },
  },
};
</script>
